import { renderToString } from 'react-dom/server';
import pipe from 'lodash.flow';

const PUNCTUATION_REGEX = /([.,/#!?$%^&*;:{}=\-_`~()\][])+$/g;

const toPx = val => `${val}px`;
const removePunctuation = word => word.replace(PUNCTUATION_REGEX, '');
const appendTail = tail => word => `${word}${tail}${tail}`;
const addSpace = word => `${word} `;

const formatLastNode = tail =>
  pipe(removePunctuation, appendTail(tail), addSpace);

const getTruncatedIndex = ({
  text,
  maxHeight,
  width,
  font,
  lineHeight,
  expand,
  tail,
  fontLoaded,
}) => {
  if (!maxHeight || !fontLoaded) return -1;
  const container = document.createElement('div');
  Object.assign(container.style, {
    position: 'absolute',
    visibility: 'hidden',
    zIndex: -1,
    width: toPx(width),
    lineHeight: toPx(lineHeight),
    font,
  });
  document.body.appendChild(container);
  const textNodes = text ? [...text.split(' '), ''] : [];
  const wordCount = textNodes.length - 1;
  container.innerHTML = textNodes.join(' ');
  const button = document.createElement('span');
  button.innerHTML = renderToString(expand);
  while (maxHeight < container.clientHeight && textNodes.length > 0) {
    textNodes.pop();
    textNodes[textNodes.length - 1] = formatLastNode(tail)(
      textNodes[textNodes.length - 1],
    );
    container.innerHTML = textNodes.join(' ');
    container.appendChild(button);
  }
  container.parentNode.removeChild(container);
  if (wordCount === textNodes.length - 1) return -1;
  return textNodes.length - 1;
};

export default getTruncatedIndex;
